"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindowServiceInstance = void 0;
var _tenants = require("./tenants");
var _WindowAPI = _interopRequireDefault(require("./WindowAPI"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getWindowServiceInstance = props => {
  var _props$config, _TENANT_SERVICE$tenan, _TENANT_SERVICE$tenan2;
  const tenant = (_props$config = props.config) === null || _props$config === void 0 ? void 0 : _props$config.tenant;
  const tenantService = (_TENANT_SERVICE$tenan = (_TENANT_SERVICE$tenan2 = _tenants.TENANT_SERVICE[tenant]) === null || _TENANT_SERVICE$tenan2 === void 0 ? void 0 : _TENANT_SERVICE$tenan2.windowAPI) !== null && _TENANT_SERVICE$tenan !== void 0 ? _TENANT_SERVICE$tenan : _WindowAPI.default;
  return new tenantService(props);
};
exports.getWindowServiceInstance = getWindowServiceInstance;